export default __webpack_public_path__ + "static/media/57.1600a99d.png";